export const OFFER_DETAIL_TESTID = {
    OFFER_HEADER: "offer-detail-header"
};
